import type { TableColumnSort } from '@ipfabric/utils';
import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';
import { reloadTableData } from 'components/ApiTable/model/commands/reloadTableData';

export interface ChangeSortCommand {
  sort: TableColumnSort;
}

export const changeSort: ApiTableCommandFactory<ChangeSortCommand> =
  (cmdContext, dispatch) => async (command) => {
    cmdContext.updateState((draft) => {
      draft.sort = command.sort;
    });
    dispatch(reloadTableData);
  };
